import VConsole from 'vconsole';

// 替换域名，使用指定网址中的域名替换当前域名
window.replaceSite = (url: string | null) => {
  if (!url) {
    url = window.prompt('请输入网址，将使用该网址的域名替换当前域名');
  }

  if (url === null) {
    return;
  }

  if (!/https?:\/\//.test(url!)) {
    alert('网址不合法，请重新输入');
    return;
  }

  url = location.href.replace(location.origin, new URL(url!).origin);

  location.replace(url!);
};

// 替换网址，使用指定的网址替换当前网址
window.replaceUrl = (url: string | null) => {
  if (!url) {
    url = window.prompt('请输入网址，将使用该网址替换当前网址');
  }

  if (url === null) {
    return;
  }

  if (!/https?:\/\//.test(url!)) {
    alert('网址不合法，请重新输入');
    return;
  }

  location.replace(url!);
};

const myPlugin = new VConsole.VConsolePlugin('kp', 'kp');

myPlugin.on('ready', function () {
  console.log('快批vConsole插件初始化完成');
});

myPlugin.on('renderTab', function (callback) {
  const html =
    '<div>快批vConsole插件面板，请点击下方的按钮执行相应的功能</div>';
  callback(html);
});

myPlugin.on('addTool', function (callback) {
  const refreshButton = {
    name: '刷新页面',
    onClick: () => {
      const newUrl = new URL(location.href);
      const { searchParams } = newUrl;

      if (searchParams.has('t')) {
        searchParams.set('t', Date.now().toString());
      } else {
        searchParams.append('t', Date.now().toString());
      }

      location.href = newUrl.toString();
    },
  };

  const replaceSiteButton = {
    name: '替换域名',
    onClick: () => {
      window.replaceSite();
    },
  };

  const replaceUrlButton = {
    name: '替换网址',
    onClick: () => {
      window.replaceUrl();
    },
  };

  callback([
    refreshButton,
    replaceSiteButton,
    replaceUrlButton,
  ]);
});

export default myPlugin;
